export const environment = {
  production: false,
  name: 'staging',
  apiUrl: 'https://staging.api.dev-modeler.nicosworld.eu',
  timeCloseModal: 2000,
  take: 1,
};
